export function calculateScore(answers, questionnaire) {
  const allQuestions = questionnaire.sections.flatMap((s) => s.questions);
  const total = allQuestions.length;
  if (total === 0) return 0;
  const correct = allQuestions.filter(
    (q) => answers[q.globalId] === q.correctOption
  ).length;
  return correct / total;
}
